{
    "eventCategoryHeading":"Manage event category",
    "addBtnText":"Add",
    "popupHeadingText":"Create event category",
    "editPopupHeadingText":"Edit event category",
    "createText":"Create",
    "eventName":"Event name",
    "somethingWentWrong":"Something went wrong",
    "eventCategoryName":"Event category",
    "eventCategoryPlaceholder":"Enter event category name",
    "colorCode":"Select color code",
    "closeText":"Close",
    "requiredEventCategoryName":"Event category name is required",
    "requiredEventCategoryColor":"Event category color is required",
    "createEventCategorySuccessMessage":"Category has been added successfully",
    "CategoryFailedToCreateErrorText":"Failed to created category",
    "pleaseFillDetailsErrorMessage":"Please fill all the details",
    "maxCharEventCategoryName":"Maximum 200 characters allowed",
    "minCharEventCategoryName":"Minimum 3 characters required",
    "editText":"Save",
    "deleteText":"Delete",
    "deleteHeadingModal":"Delete category",
    "confirmDeleteHeadingModal":"Confirm delete event",
    "deletConfirmStatement":"Are you sure you want to delete?",
    "eventSingular":"event",
    "eventPlural":"events",
    "whenEventScheduleInDeleteCategory":" is already scheduled with this event category",
    "giveDeleteEventCondition":"If you delete this event category, scheduled event is also deleted",
    "CategoryFailedToEditErrorText":"Unable to update event category",
    "editEventCategorySuccessMessage":"Event category has been edited successfully",
    "pleaseProvideValueCharErrorMessage":"Please provide valid characters",
    "deleteEventCategoryError":"Unable to delete event category",
    "deletEventCategorySuccessfull":"Event category has been deleted successfully",
    "noDataAvailable":"No data available to show",
    "requiredParam":"*",
    "unableToFetchEventCategory":"Unable to fetch event category list"
}